import { Navigate, useLocation } from "react-router";

import { getSessionAuth } from "store/local";

// Public pages (home/login): if a session already exists, go to the dash.
export function PublicOnly({ children }) {
  const session = getSessionAuth();
  if (session) {
    return <Navigate to={`/dash/${session.db ?? ""}`} replace />;
  }
  return children;
}

// Private pages (/dash): without a session, go to the login.
export function RequireAuth({ children }) {
  const location = useLocation();
  if (!getSessionAuth()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
